<template>
  <div>
    <div class="flex p-3 justify-between" :class="{ lock: data.lock }">
      <div class="flex flex-row">
        <img
          :src="data.profile_picture"
          alt=""
          class="w-8 h-8 rounded-full mr-2"
        />

        <div>
          <h3 class="text-sm font-medium text-black">{{ data.name }}</h3>
          <p class="text-xs font-medium text-606770 mt-2">{{ data.country }}</p>
        </div>
      </div>
      <div
        :class="{ lock: data.lock }"
        class="flex gap-2 justify-left content-center items-center"
      >
        <div
          class="cursor-pointer w-8 h-8 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="viewCreatorInfo(data)"
        >
          <div class="group w-full flex items-center justify-center">
            <div>
              <Icon name="Contact" fill="#fff" stroke="#667eea" class="w-6" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="relative">
      <div class="square" v-if="!data.lock" :class="{ lock: data.lock }">
        <video class="w-full" controls>
          <source :src="data.videos[0]" />
        </video>
      </div>
      <template v-if="data.lock">
        <UnlockUGC class="relative top-0 unlock" />
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";
import { useRouter } from "vue-router";
import UnlockUGC from "@/components/UnlockUGC";

export default {
  components: { Icon, UnlockUGC },
  props: {
    data: Object,
    isCollection: Boolean,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const primaryTextClamp = ref(true);
    const roleUser = computed(() => store.state.role);

    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };

    const viewCreatorInfo = async (data) => {
      store.commit("SET_SELECTED_UGC_CREATOR", data);

      router.push({
        path: "/ugc-creator-info",
        data: data,
      });
    };

    return {
      roleUser,
      primaryTextClamp,
      togglePrimaryTextClamp,
      viewCreatorInfo,
    };
  },
};
</script>

<style>
.post {
  filter: blur(8px);
}
.unlock {
  z-index: 1;
}
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  background-color: black;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.advertisements__item__media {
  width: 100%;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
